import { render, staticRenderFns } from "./form-risk-attendance.view.vue?vue&type=template&id=c21d4518&scoped=true&"
import script from "./form-risk-attendance.view.vue?vue&type=script&lang=ts&"
export * from "./form-risk-attendance.view.vue?vue&type=script&lang=ts&"
import style0 from "./form-risk-attendance.view.vue?vue&type=style&index=0&id=c21d4518&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21d4518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
